var controller = new ScrollMagic.Controller({
    globalSceneOptions: {
        reverse: true
    }
});

var s3_animate = new TimelineLite();
var _ref = [TweenMax.to(".img-1", 2, {
    y: '8%'
}), TweenMax.to(".img-2", 2, {
    y: '8%'
}), TweenMax.to(".img-3", 2, {
    y: '8%'
})],
    s3_tween1 = _ref[0],
    s3_tween2 = _ref[1];
s3_tween3 = _ref[2];

s3_animate.add([s3_tween1, s3_tween2, s3_tween3], 0);

new ScrollMagic.Scene({
    triggerElement: '#container1',
    triggerHook: 1,
    duration: 4000,
    offset: 0
}).setTween(s3_animate).addTo(controller);